<template>
  <div class="recover">
    <div class="recover-wrapper">
      <img :src="require('@/assets/images/logo_sas_portrait.svg')" />
      <h1>Insira seu e-mail para recuperar</h1>
      <input type="email" placeholder="E-mail" name="email" v-model="email" required />
      <button>Recuperar</button>

      <router-link class="recover-login" :to="{ name: 'login' }">
        Lembrei minha senha</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Recover',
  data() {
    return {
      email: '',
      password: '',
    };
  },
  beforeCreate() {
    this.$store.commit('headerModeApp');
  },
};
</script>

<style scoped>
  .recover{
    width: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 60px;
  }
  .recover-wrapper{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
  }
  img{
    height: 90px;
    object-fit: contain;
    margin-bottom: 60px;
  }
  .recover-login{
    margin-top: 100px;
  }
</style>
